import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  /** 'inline' comprime el bloque en una fila (hero mobile). */
  layout?: 'stack' | 'inline';
  tone?: 'light' | 'dark';
}

/**
 * Único bloque de precio de la landing: precio anterior tachado,
 * etiqueta de oferta en verde y precio vigente grande.
 */
export function PriceBlock({
  className = '',
  size = 'md',
  layout = 'stack',
  tone = 'light'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3rem] sm:text-[3.6rem]' : size === 'sm' ? 'text-[2.1rem] sm:text-[2.5rem]' : 'text-[2.6rem] sm:text-[3.1rem]';
  const previousColor = tone === 'dark' ? 'text-white/45' : 'text-slate';
  const currentColor = tone === 'dark' ? 'text-white' : 'text-ink';
  const noteColor = tone === 'dark' ? 'text-white/55' : 'text-slate';
  if (layout === 'inline') {
    return <div className={`flex flex-col items-center ${className}`} data-id="element-156" data-mp="wg30v0658upg">
        <div className="flex items-center justify-center gap-2.5" data-id="element-157" data-mp="1s09rjivgsjlp">
          <p className={`font-sans text-[0.95rem] font-medium tabular-nums ${previousColor}`} style={{
          textDecoration: 'line-through'
        }} data-id="element-158" data-mp="1rxx8t3hvu57l">
            {PRICE.previous}
          </p>
          <p className={`font-display font-extrabold leading-none tracking-tight tabular-nums ${current} ${currentColor}`} data-id="element-159" data-mp="26oeb0p2ccz5j">
            {PRICE.current}
          </p>
        </div>
        <p className={`mt-1.5 font-sans text-[0.68rem] font-semibold uppercase tracking-[0.1em] ${noteColor}`} data-id="element-160" data-mp="1dzqic8f9j7hy">
          {PRICE.note}
        </p>
      </div>;
  }
  return <div className={`flex flex-col items-center ${className}`} data-id="element-161" data-mp="1n0ezhbzydnz2">
      <div className="flex items-center gap-2.5" data-id="element-162" data-mp="1n1zqirn26os6">
        <p className={`font-sans text-sm font-medium tabular-nums sm:text-base ${previousColor}`} style={{
        textDecoration: 'line-through'
      }} data-id="element-163" data-mp="2uf06lgv5sqyn">
          {PRICE.previous}
        </p>
        <span className="rounded-full bg-wa px-2.5 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.1em] text-ink" data-id="element-164" data-mp="za0tftxy02dk">
          Oferta
        </span>
      </div>
      <p className={`mt-1 font-display font-extrabold leading-[0.95] tracking-tight tabular-nums ${current} ${currentColor}`} data-id="element-165" data-mp="18biabej6c83b">
        {PRICE.current}
      </p>
      <p className={`mt-2 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.12em] ${noteColor}`} data-id="element-166" data-mp="13auk2v2rrva5">
        {PRICE.note}
      </p>
    </div>;
}